import { Segment } from 'src/types/search';

export default function getMatchRanges(
  segments: Segment[]
): Array<[number, number]> {
  const { indexes } = segments
    .map(segment => ({
      match: segment.match,
      text: segment.text,
    }))
    .reduce(
      (acc, segment) => ({
        indexes: [
          ...acc.indexes,
          ...(segment.match
            ? [acc.textIndex, acc.textIndex + segment.text.length]
            : []),
        ],
        textIndex: acc.textIndex + segment.text.length,
      }),
      {
        indexes: [],
        textIndex: 0,
      }
    );

  const pairedPositions: Array<[number, number]> = [];
  while (indexes.length) {
    const [start, end] = indexes.splice(0, 2);
    pairedPositions.push([start, end]);
  }
  return pairedPositions;
}
